import React, { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";

import Breadcrumbs from "../../../../components/BreadCrumbs";
import Card from "../../../../components/Card";
import messages from "../../../../assets/locale/messages";
import { ROUTE_PATHS } from "../../../../utils/RoutesPaths";
import { UIPageFormFooter } from "../../../../components/ui";
import { createCompanyClientRequest } from "../../../../store/CompanyPortal/Clients/actions";
import { buildCreateCompanyClientPayload } from "../clientMappers";
import ClientFormFields from "../ClientForm/ClientFormFields";

import "../ClientForm/ClientForm.scss";

const CompanyAddClient = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const lang = useSelector((state) => state.locale.lang);
  const creating = useSelector((state) => state.companyClients.creating);
  const { clients, shared, inputsValidations } = messages[lang];
  const addClientCopy = clients.addClient;
  const clientsBreadcrumb =
    clients.listClients.listClientsBreadcrumb || clients.title;

  const goBackToList = useCallback(() => {
    history.push(ROUTE_PATHS.companyClients);
  }, [history]);

  const formik = useFormik({
    initialValues: {
      name: "",
      email: "",
      phone: "",
      phoneCountryDialCode: "966",
    },
    validationSchema: Yup.object({
      name: Yup.string().trim().required("nameRequired"),
      email: Yup.string()
        .trim()
        .email("validEmailFormat")
        .required("emailRequired"),
      phone: Yup.string().nullable(),
    }),
    onSubmit: (values) => {
      dispatch(
        createCompanyClientRequest({
          data: buildCreateCompanyClientPayload(values),
          onSuccess: goBackToList,
        }),
      );
    },
  });

  const handleCancel = () => {
    history.push(ROUTE_PATHS.companyClients);
  };

  return (
    <div className="company-client-form add-client">
      <Breadcrumbs
        list={[
          {
            path: ROUTE_PATHS.companyClients,
            label: clientsBreadcrumb,
          },
          {
            path: "",
            label: addClientCopy.addNewClientTitle,
          },
        ]}
        BreadCrumbHasBackIcon={false}
      />

      <h2 className="page-title">{addClientCopy.addNewClientTitle}</h2>

      <form onSubmit={formik.handleSubmit}>
        <Card
          title={clients.details}
          classNames={{ body: "company-portal-profile-card__body" }}
        >
          <ClientFormFields
            clients={clients}
            formik={formik}
            inputsValidations={inputsValidations}
          />
        </Card>

        <UIPageFormFooter
          cancelLabel={shared.cancel}
          submitLabel={shared.confirm}
          onCancel={handleCancel}
          submitType="submit"
          submitDisabled={!formik.dirty || !formik.isValid || creating}
          submitLoading={creating}
          cancelDisabled={creating}
        />
      </form>
    </div>
  );
};

export default CompanyAddClient;
